// extracted by mini-css-extract-plugin
export default {"InputText":"InputText_InputText__JilPB","InputText__Input":"InputText_InputText__Input__EUjSz","disabled":"InputText_disabled__mpfE-"};